import { useContext } from "react";
import { OrgSiteGroupTreeContext } from "./OrgSiteGroupTreeContext";

const useOrgSiteGroupTreeContext = () => {
    return useContext(OrgSiteGroupTreeContext);
};

export default useOrgSiteGroupTreeContext;
